/// <reference path="../../typings/browser.d.ts" />

namespace Application.Services {
    'use strict';

    /**
     * Login service class
     */
    export class LoginService {
        public static $name: string = "loginService";
        public static $inject: string[] = ['base64',
                                           '$http',
                                           '$cookies',
                                           '$rootScope',
                                           '$location',
                                           "$q",
                                           '$route',
                                           '$window',
                                           '$timeout'];
        public static AUTH_HEADER_COOKIE_KEY: string = 'flex_auth_header';

        private base64: Application.Services.Base64Service;
        private $http: ng.IHttpService;
        private $cookies: ng.cookies.ICookiesService;
        private $rootScope: IFlexRootScope;
        private $location: ng.ILocationService;
        private qService: ng.IQService;
        private $route: ng.route.IRouteService;
        private $window: ng.IWindowService;
        private $timeout: ng.ITimeoutService;

        private backendBaseUrl: string = window.backendUrl;
        private servicePath: string = '';
        private loginBackendUrl: string = this.backendBaseUrl + this.servicePath + 'login';
        private checkBackendUrl: string = this.backendBaseUrl + this.servicePath + 'currentUser';
        private logoutBackendUrl: string = this.backendBaseUrl + this.servicePath + 'logout';
        private authKey: string = 'Authorization';

        /**
         * Constructor
         */
        constructor(base64: Application.Services.Base64Service,
                    $http: ng.IHttpService,
                    $cookies: ng.cookies.ICookiesService,
                    $rootScope: IFlexRootScope,
                    $location: ng.ILocationService,
                    $q: ng.IQService, $route: ng.route.IRouteService,
                    $window: ng.IWindowService,
                    $timeout: ng.ITimeoutService) {
            this.base64 = base64;
            this.$http = $http;
            this.$cookies = $cookies;
            this.$rootScope = $rootScope;
            this.$location = $location;
            this.qService = $q;
            this.$route = $route;
            this.$window = $window;
            this.$timeout = $timeout;

            this.isLoggedIn(this.$location.path());
        }

        public login(user: string, password: string, returnPath?: string, authData?: string): void {
            authData = authData ? authData : this.base64.encode(user + ":" + password);
            returnPath = returnPath ? returnPath : '/';

            this.$http.defaults.headers.common[this.authKey] = 'Basic ' + authData;
            this.$http(
                {
                    method: "GET",
                    url: this.checkBackendUrl,
                    headers: { 'Authorization': 'Basic ' + authData },
                }).success (() => {
                    this.loginSuccesful(returnPath, authData);
                }).error((reason: ngCustom.IReason) => {
                    this.loginError(reason.status);
                });
        }

        public directLogin(authData: string, returnPath?: string): void {
            this.login(undefined, undefined, returnPath, authData);
        }

        public doFormLogin(username: string, password: string, returnPath?: string): ng.IPromise<{}> {
            returnPath = returnPath && returnPath !== '/login' ? returnPath : '/';
            return this.$http({
                method: 'POST',
                url: this.loginBackendUrl,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                transformRequest: (obj: Object) => {
                    let str: string[] = [];
                    str.push(encodeURIComponent("username") + "=" + encodeURIComponent(username));
                    str.push(encodeURIComponent("password") + "=" + encodeURIComponent(password));
                    return str.join("&");
                },
                data: {username: username, password: password},
            }).catch(() => {
                // ignore it
                return {};
            }).finally(() => {
                this.isLoggedIn(undefined, true);
            });
        }

        public logout(): void {
            this.$rootScope.vars.isUserLoggedIn = false;
            this.$rootScope.vars.connectionLocked = false;
            this.$http.defaults.headers.common[this.authKey] = undefined;
            this.$http.get(this.logoutBackendUrl).finally(() => {
                this.$cookies.remove(LoginService.AUTH_HEADER_COOKIE_KEY);
                this.$location.path('/logout');
                this.$rootScope.$emit('vars.isUserLoggedIn', false);
            });
        }

        public isLoggedIn(returnPath?: string, noRedirect?: boolean): ng.IHttpPromise<boolean> {
            returnPath = returnPath && returnPath !== '/login' ? returnPath : '/';
            return this.$http({
                    method: "GET",
                    url: this.checkBackendUrl,
                }).success((data: Object, status: number) => {
                    let key: string = "username";
                    if (data[key]) {
                        this.loginSuccesful(returnPath, undefined, noRedirect);
                    } else {
                        this.loginError(status);
                    }
                    return true;
                }).error((reason: ngCustom.IReason) => {
                    return false;
                });
        }

        private loginSuccesful(returnPath: string, authData?: string, noRedirect?: boolean): void {
            if (authData)
                this.$cookies.put(LoginService.AUTH_HEADER_COOKIE_KEY, authData); // tODO CONFIG!!

            if (!noRedirect) {
                this.$location.path(returnPath);
                this.$location.search('returnPath', undefined);
                this.$location.search('login', undefined);
                this.$location.search('password', undefined);
            }
            this.$rootScope.$broadcast('isBackendPresent', true);
            this.$rootScope.vars.isUserLoggedIn = true;
            this.$rootScope.$broadcast('vars.isUserLoggedIn', true);
        }

        private loginError(status: number): void {
            this.$timeout(() => {
                (this.$rootScope as IFlexRootScope).vars.isUserLoggedIn = false;
            });
            if (status !== 401 && status !== 403)
                this.$rootScope.$broadcast('isBackendPresent', true);
            else
                this.$rootScope.$broadcast('isBackendPresent', false);
            Common.Utils.closeStickyAlerts();
            Common.Utils.stickyAlert("Unauthorized...", "info", BackendService.SECONDS_TO_RETRY);
            this.$http.defaults.headers.common[this.authKey] = '';
            this.$location.path('/login');
        }
    }
}
